import React, { useState } from 'react';
import axios from 'axios';

export default function SemanticGap() {
  const [userText, setUserText] = useState('');
  const [compText, setCompText] = useState('');
  const [compUrl, setCompUrl] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAnalyze = async () => {
    setLoading(true);
    setResults(null);
    try {
      const res = await axios.post('https://seodash360.com/api/semantic/v3-ultimate', {
        user_text: userText,
        competitor_text: compText,
        competitor_url: compUrl
      });
      setResults(res.data);
    } catch (err) {
      console.error(err);
      alert("Erreur : Le serveur V3 ne répond pas. Vérifiez le Backend.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0f172a] text-white p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8 text-blue-400">NeuralLink Expert V3</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <textarea 
            className="w-full h-64 p-4 bg-slate-900 border border-slate-700 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none text-gray-200"
            placeholder="Votre texte..."
            value={userText} onChange={e => setUserText(e.target.value)}
          />
          <div className="flex flex-col gap-4">
            <input 
              type="text"
              placeholder="Coller l'URL d'un concurrent ici (ex: Marmiton)..."
              className="w-full p-4 bg-slate-900 border border-indigo-500/50 rounded-xl outline-none text-indigo-200 placeholder-indigo-700"
              value={compUrl} onChange={e => setCompUrl(e.target.value)}
            />
            <textarea 
              className="w-full h-44 p-4 bg-slate-900 border border-slate-700 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none text-gray-200"
              placeholder="OU Texte concurrent manuel..."
              value={compText} onChange={e => setCompText(e.target.value)}
            />
          </div>
        </div>

        <button 
          onClick={handleAnalyze} disabled={loading}
          className="w-full py-4 bg-blue-600 hover:bg-blue-500 disabled:bg-gray-700 rounded-xl font-bold text-xl transition-all shadow-lg mb-8"
        >
          {loading ? "Analyse V3 & IA en cours..." : "Lancer l'Expertise Sémantique"}
        </button>

        {results && (
          <div className="mt-12 space-y-8 animate-in fade-in duration-500">
            <div className="bg-slate-800 border border-slate-700 p-8 rounded-2xl flex justify-between items-center">
              <span className="text-xl text-slate-400">Score de Similarité</span>
              <span className="text-6xl font-black text-blue-400">{results.score}%</span>
            </div>

            {/* BLOC IA RÉDACTION - LE NOUVEAU CERVEAU */}
            {results.ai_correction && (
              <div className="bg-indigo-900/30 border border-indigo-500/50 p-8 rounded-2xl shadow-2xl">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-indigo-300 font-bold text-xl flex items-center gap-2">
                    🚀 CODE HTML OPTIMISÉ (PRÊT À COPIER)
                  </h3>
                  <button 
                    onClick={() => {navigator.clipboard.writeText(results.ai_correction); alert("Copié !")}}
                    className="bg-indigo-600 hover:bg-indigo-500 px-4 py-2 rounded-lg text-sm font-bold transition-colors"
                  >
                    Copier le Post
                  </button>
                </div>
                <div className="text-emerald-400 font-mono text-xs whitespace-pre-wrap bg-slate-950/50 p-6 rounded-xl border border-slate-800">
                  {results.ai_correction}
                </div>
              </div>
            )}

            <div className="bg-gradient-to-br from-indigo-950/40 to-slate-900 border border-indigo-500/30 p-6 rounded-2xl">
              <h3 className="text-indigo-400 font-bold text-lg mb-3 flex items-center">💡 Conseil Rapide</h3>
              <p className="text-slate-200 italic leading-relaxed">"{results.suggestion_text}"</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-red-950/20 border border-red-900/30 p-6 rounded-2xl">
                <h3 className="text-red-400 font-bold mb-4 uppercase text-sm">⚠️ Gap (Manquant)</h3>
                <div className="flex flex-wrap gap-2">
                  {results.missing_entities?.map((ent, i) => (
                    <span key={i} className="px-3 py-1 bg-red-900/40 border border-red-500/20 rounded-lg text-xs text-red-200">{ent}</span>
                  ))}
                </div>
              </div>
              <div className="bg-green-950/20 border border-green-900/30 p-6 rounded-2xl">
                <h3 className="text-green-400 font-bold mb-4 uppercase text-sm">✅ Maîtrisé</h3>
                <div className="flex flex-wrap gap-2">
                  {results.user_entities?.map((ent, i) => (
                    <span key={i} className="px-3 py-1 bg-green-900/40 border border-green-500/20 rounded-lg text-xs text-green-200">{ent}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
